import { HotelEdge } from './HotelBookInformation.types';

export const processHotelSearchResultsWithRequiredFields = (hotelResults: HotelEdge[]) => {
  return hotelResults
    .filter(hotelData => hotelData.node.name && hotelData.node.propertyID)
    .map(hotelData => ({
      hotelName: hotelData.node.name,
      hotelPropertyId: hotelData.node.propertyID,
      hotelCity: hotelData.node.city,
      hotelRegion: hotelData.node.region?.code,
      hotelCountry: hotelData.node.country?.description,
    }));
};

export const formatHotelFieldsWithRequiredLabels = (hotel: {
  hotelName: string;
  hotelCity: string;
  hotelRegion: string | undefined;
  hotelCountry: string;
}) => {
  const { hotelName, hotelCity, hotelRegion, hotelCountry } = hotel;
  return `${hotelName} - ${hotelCity}${hotelRegion ? `, ${hotelRegion}` : ''}, ${hotelCountry}`;
};
